module.exports = __webpack_public_path__ + "static/img/RoadmapSample.2f3bdd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RoadmapSample.png
// module id = b+YV
// module chunks = 62